import { render, staticRenderFns } from "./TAC.vue?vue&type=template&id=43223746&"
import script from "./TAC.vue?vue&type=script&lang=js&"
export * from "./TAC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports